<template>
	<div class="change-password-dialog">
		<el-dialog append-to-body :title="row ? '修改主体' : '添加主体'" :visible="show" :close-on-click-modal="false" width="500px" @close="closeDialog">
			<el-form ref="vForm" class="form" :model="vForm" label-width="100px" auto-complete="off" size="medium">
				<el-form-item label="主体名称" class="form-group" prop="name" :rules="{ required: true, message: '主体名称必填' }">
					<el-input v-model="vForm.name" type="text" class="form-control" />
				</el-form-item>
<!--				<el-form-item label="首页链接" class="form-group" prop="alias" :rules="{ required: true, message: '网站首页必填' }">-->
<!--					<el-input v-model="vForm.alias" type="text" class="form-control">-->
<!--						<template slot="prepend">https://</template>-->
<!--						<template slot="append">-vr.vyb.cn</template>-->
<!--					</el-input>-->
<!--				</el-form-item>-->
				<el-form-item label="所属行政区" class="form-group" prop="area" :rules="{ required: true, message: '所属行政区必填' }">
					<el-cascader v-model="regionDataSelected" placeholder="点击选择" style="width: 100%" :options="regionData" filterable :props="{value: 'label',label: 'label',expandTrigger: 'hover'}" @change="handleRegionChange"></el-cascader>
				</el-form-item>
				<el-form-item label="主体类型" class="form-group" required>
					<el-radio v-model="vForm.type" :label="1">SaaS</el-radio>
					<el-radio v-model="vForm.type" :label="2">代理商</el-radio>
				</el-form-item>
				<el-form-item label="状态" class="form-group" required>
					<el-radio v-model="vForm.status" :label="1">启用</el-radio>
					<el-radio v-model="vForm.status" :label="2">禁用</el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">取 消</el-button>
				<el-button type="primary" :loading="doSubmitLoading" size="small" @click="doSubmit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {regionData} from 'element-china-area-data'

	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			row: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				doSubmitLoading: false,
				vForm: {
					id: "",
					name: "",
					province: "",
					city: "",
					area: "",
					type: 1,
					status: 1,
				},
				loading: false,
				regionData,
				regionDataSelected: []
			};
		},
		created() {
			if (this.row) {
				for (let key in this.vForm) {
					this.vForm[key] = this.row[key]
				}
				this.regionDataSelected = [this.row.province, this.row.city, this.row.area];
			}
		},
		methods: {

			closeDialog() {
				this.$emit("update:show", false);
			},

			//选择行政区域
			handleRegionChange(region) {
				this.vForm.province = region[0];
				this.vForm.city = region[1];
				this.vForm.area = region[2];
				this.$refs.vForm.validateField('area')
			},

			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.$refs.vForm.validate();
					let res = await this.api.subject[this.row ? "edit" : "add"](this.vForm);
					this.$message.success(res.message);
					this.closeDialog();
					this.$emit("success");
				} catch (ex) {
					console.error(ex);
				}
				this.doSubmitLoading = false;
			}
		}
	};
</script>

<style lang="scss" scoped>

</style>
